import GetClassesRequestModelBase from '../_generated/modelBases/get-classes-request-model-base';

export default class GetClassesRequestModel extends GetClassesRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
